module.exports = __webpack_public_path__ + "img/008_Onboarding session icon.e1ee5e8c.png";